import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { OrderModel } from '@core/api';

@Component({
  selector: 'user-active-deals',
  templateUrl: './user-active-deals.component.html',
  styleUrls: ['./user-active-deals.component.scss']
})
export class UserActiveDealsComponent {

  allowedStatuses = [
    OrderModel.StatusEnum.Created,
    OrderModel.StatusEnum.Verified,
    OrderModel.StatusEnum.Paid,
    OrderModel.StatusEnum.InRent
  ];

  constructor(
    public dialog: MatDialog
  ) { }

}
